import React from 'react';
import PropTypes from 'prop-types';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import SocialNetworks from '@plonegovbr/volto-social-media/components/SocialNetworks/SocialNetworks';
import { getSpeakerImageUrl } from '../../Session/utils';

const SpeakerTemplate = ({
  headlineTag,
  items,
  linkTitle,
  linkHref,
  isEditMode,
}) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <UniversalLink href={href}>{linkTitle || href}</UniversalLink>;
  }

  const getTitleTag = (tag) => {
    const level = Number(tag?.slice(-1));
    if (Number.isInteger(level) && level >= 1 && level <= 6) {
      return `h${Math.min(level + 1, 6)}`;
    }
    return 'h3';
  };
  const TitleTag = getTitleTag(headlineTag);

  return (
    <>
      <div className="items speaker-listing">
        {items.map((item) => {
          const imgUrl = getSpeakerImageUrl(item);
          const hasSocial = item.social_links && item.social_links.length > 0;
          const hasActivities = item.activities && item.activities.length > 0;

          return (
            <div className="speaker-card" key={item['@id']}>
              <div className="speaker-card__header">
                <div className="speaker-card__photo-wrapper">
                  {imgUrl ? (
                    // eslint-disable-next-line no-restricted-syntax
                    <img
                      src={imgUrl}
                      alt={item.title}
                      className="speaker-card__photo"
                    />
                  ) : (
                    <div className="speaker-card__photo placeholder" />
                  )}
                </div>
                <div className="speaker-card__title-area">
                  <TitleTag className="speaker-card__title">
                    <UniversalLink href={flattenToAppURL(item['@id'])}>
                      {item.title}
                    </UniversalLink>
                  </TitleTag>
                  {hasSocial && (
                    <div className="speaker-card__social">
                      <SocialNetworks networks={item.social_links} animate />
                    </div>
                  )}
                </div>
              </div>

              {item.description && (
                <p className="speaker-card__description">{item.description}</p>
              )}

              {hasActivities && (
                <div className="speaker-card__sessions">
                  {item.activities.map((group) => (
                    <div
                      key={group['@id']}
                      className="speaker-card__session-group"
                    >
                      <span className="session-item__chip">{group.title}</span>
                      <ul className="speaker-card__session-list">
                        {group.items.map((session) => (
                          <li key={session['@id']}>
                            <UniversalLink
                              href={flattenToAppURL(session['@id'])}
                              className="speaker-card__session-link"
                            >
                              {session.title}
                            </UniversalLink>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

SpeakerTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkTitle: PropTypes.string,
  linkHref: PropTypes.arrayOf(PropTypes.any),
  isEditMode: PropTypes.bool,
  headlineTag: PropTypes.string,
};

export default SpeakerTemplate;
